import { Lang, SHORT_LANG } from './const'

const linkResolver = (doc: { lang: string; uid?: string | null; type: string }): string => {
	const { uid, type } = doc
	const lang = doc.lang as Lang

	if (type === 'anchor') {
		return `#${uid}`
	} else if (type === 'header' || type === 'footer') {
		return `/${SHORT_LANG[lang]}/`
	}

	const route = uid === 'index' ? `/${SHORT_LANG[lang]}/` : `/${SHORT_LANG[lang]}/${uid}/`

	//static generation or existing route for preview
	if (typeof window === 'undefined' || window.__ROUTES__.includes(route)) {
		return route
	}

	//route unpublished documents to generic page
	return `/${SHORT_LANG[lang]}/unpublished/`
}

export default linkResolver
